import React, { useEffect, useState } from "react";
import { buttonIcon, titleIcon } from "../../assets/images";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const BlogCard = ({ slide, currentLanguage, getLocalizedField }) => ( 
  <a href={`/${currentLanguage}/blogs/${slide.id}`} key={slide.id}>
    <div className="min-h-[510px] px-[25px] py-[32px] border border-[#CFCFCF] rounded-[24px]">
      <img
        className="w-full"
        src={`https://www.elzabeauty.az/elza/${slide.image}`}
        alt={slide.title}
      />
      <p className="text-[#393941] mt-5">{getLocalizedField(slide, "date")}</p>
      <p className="mt-5 text-[#393941] text-[20px] font-bold">
        {getLocalizedField(slide, "title")}
      </p>
      <p className="mt-2 text-[#393941]">
        {getLocalizedField(slide, "content")
          .replace(/<[^>]*>/g, "")
          .slice(0, 50)}
        ...
      </p>
    </div>
  </a>
);

const BlogDetail = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [others, setOthers] = useState([]);
  const { id } = useParams();

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  useEffect(() => {
    const getProducts = async () => {
      try {
        const response = await axios.get(
          "https://www.elzabeauty.az/elza/blogs.php"
        );
        const data = response.data.data || [];
        setList(data);
        const filteredOthers = data
          .filter((item) => parseInt(item.id) !== parseInt(id))
          .slice(0, 3);
        setOthers(filteredOthers);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getProducts();
  }, [id]);

  const filteredProduct = list.find((product) => product.id == id);

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  if (isLoading) {
    return <div className="text-center py-20">Yüklənir...</div>;
  }

  return (
    <>
      <Helmet>
        <title>{getLocalizedField(filteredProduct, "meta_tag_title")}</title>
        <meta
          name="description"
          content={getLocalizedField(filteredProduct, "meta_tag_description")}
        />
        <meta
          name="keywords"
          content={getLocalizedField(filteredProduct, "meta_tag_keywords")}
        />
      </Helmet>
      <div>
        <div className="max-w-containerSm md:max-w-container mx-auto">
          {/* Blog Detail */}
          <div className="mt-[32px] md:mt-[80px] flex flex-col-reverse md:flex-row justify-between">
            <div className="md:w-[565px] mt-5 md:mt-0">
              <p className="text-[24px] font-bold text-[#0B0B0B]">
                {getLocalizedField(filteredProduct, "title")}
              </p>
              <p className="text-[#393941] mt-5">
                {getLocalizedField(filteredProduct, "date")}
              </p>
              <p
                className="text-[#0B0B0B] mt-7"
                dangerouslySetInnerHTML={{
                  __html: getLocalizedField(filteredProduct, "content"),
                }}
              />
            </div>
            <div className="md:w-[649px]">
              <img
                className="w-full rounded-lg"
                src={`https://www.elzabeauty.az/elza/${filteredProduct?.image}`}
                alt={filteredProduct?.title}
              />
            </div>
          </div>

          {/* Other Blogs */}
          {others?.length > 0 && (
            <div className="mt-[88px] md:mt-[120px]">
              <div className="flex md:justify-between justify-center ">
                <div className="flex items-center">
                  <img alt="Title" className="w-[50px] h-auto mr-2" src={titleIcon}></img>
                  <p className="text-[24px] md:text-[28px] font-semibold text-center md:text-left text-[#181D27]">
                    {t("Digər bloqlar")}
                  </p>
                </div>
                <a
                  className="hidden md:block"
                  href={`/${currentLanguage}/products`}
                >
                  <div className="flex justify-between items-center text-[#181D27] w-[124px] h-[44px]">
                    <p>{t("Hamısına bax")}</p>
                  </div>
                </a>
              </div>

              {/* Desktop Grid */}
              <div className="hidden md:grid grid-cols-3 gap-5 mt-[34px]">
                {others.map((slide) => (
                  <BlogCard
                    key={slide.id}
                    slide={slide}
                    currentLanguage={currentLanguage}
                    getLocalizedField={getLocalizedField}
                  />
                ))}
              </div>

              {/* Mobile Swiper */}
              <div className="block md:hidden mt-[24px]">
                <Swiper
                  slidesPerView={1}
                  spaceBetween={20}
                  loop={true}
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                  }}
                  pagination={{ clickable: true }}
                  modules={[Autoplay, Pagination, Navigation]}
                  className="mySwiper"
                >
                  {others.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <BlogCard
                        key={slide.id}
                        slide={slide}
                        currentLanguage={currentLanguage}
                        getLocalizedField={getLocalizedField}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              {/* Mobile "Hamısına bax" Button */}
              <a className="block md:hidden" href={`/${currentLanguage}/blogs`}>
                <div className="flex justify-between items-center text-firstColor mt-[24px] h-[44px] w-[140px] mx-auto">
                  <p>{t("Hamısına bax")}</p>
                  <img alt="Button Icon" className="w-2" src={buttonIcon}></img>
                </div>
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
